/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemInstanceBase,
  ItemInstanceBaseOptional,
  ItemInstanceBaseMetaI,
  ItemInstanceBaseTrackedI,
} from "./item-instance-base";
import {
  ItemInstanceBaseTracked,
  ItemInstanceBaseMeta,
} from "./item-instance-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemInstanceRef,
  ItemInstanceRefOptional,
  ItemInstanceRefMetaI,
  ItemInstanceRefTrackedI,
} from "./item-instance-ref";
import {
  ItemInstanceRefTracked,
  ItemInstanceRefMeta,
} from "./item-instance-ref";

/**
 *
 * @export
 * @interface CatalogItemInstanceReportItemInstanceDTO
 */
export interface CatalogItemInstanceReportItemInstanceDTOOptional extends ItemInstanceBaseOptional {
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  endActive?: Date;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  ignoreStock?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  minQuantity?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  maxQuantity?: number;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  allowPriceOverride?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  priceOverrideMin?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  priceOverrideMax?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  priceCents?: number;
}

export interface CatalogItemInstanceReportItemInstanceDTO
  extends
    CatalogItemInstanceReportItemInstanceDTOOptional,
    ItemInstanceBase,
    ItemInstanceRef {
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  endActive?: Date;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  ignoreStock?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  minQuantity?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  maxQuantity?: number;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  allowPriceOverride?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  priceOverrideMin?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  priceOverrideMax?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  priceCents?: number;
}

export interface CatalogItemInstanceReportItemInstanceDTOTrackedI extends ItemInstanceBaseOptional {
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  ignoreStock?: boolean;
  ignoreStockIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  minQuantity?: number;
  minQuantityIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  maxQuantity?: number;
  maxQuantityIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  allowPriceOverride?: boolean;
  allowPriceOverrideIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  priceOverrideMin?: number;
  priceOverrideMinIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  priceOverrideMax?: number;
  priceOverrideMaxIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportItemInstanceDTO
   */
  priceCents?: number;
  priceCentsIsSet: boolean;
}

transformDatesMap.set(
  "CatalogItemInstanceReportItemInstanceDTO",
  function (model: CatalogItemInstanceReportItemInstanceDTO) {
    if (typeof model.startActive == "string")
      model.startActive = new Date(model.startActive);
    if (typeof model.endActive == "string")
      model.endActive = new Date(model.endActive);
  },
);

export type CatalogItemInstanceReportItemInstanceDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  ignoreStock: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  minQuantity: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  maxQuantity: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  allowPriceOverride: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  priceOverrideMin: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  priceOverrideMax: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  priceCents: PropertyMeta<MetaTypeBase<number>>;
}>;

export var CatalogItemInstanceReportItemInstanceDTOMeta: CatalogItemInstanceReportItemInstanceDTOMetaI =
  {} as CatalogItemInstanceReportItemInstanceDTOMetaI;
CatalogItemInstanceReportItemInstanceDTOMeta = typeMeta(
  "CatalogItemInstanceReportItemInstanceDTO",
  {
    assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
    tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
    startActive: propertyMeta(
      "startActive",
      false,
      false,
      false,
      MetaTypesBase.Date,
    ),
    endActive: propertyMeta(
      "endActive",
      false,
      false,
      false,
      MetaTypesBase.Date,
    ),
    ignoreStock: propertyMeta(
      "ignoreStock",
      false,
      false,
      false,
      MetaTypesBase.boolean,
    ),
    minQuantity: propertyMeta(
      "minQuantity",
      false,
      false,
      false,
      MetaTypesBase.number,
    ),
    maxQuantity: propertyMeta(
      "maxQuantity",
      false,
      false,
      false,
      MetaTypesBase.number,
    ),
    allowPriceOverride: propertyMeta(
      "allowPriceOverride",
      false,
      false,
      false,
      MetaTypesBase.boolean,
    ),
    priceOverrideMin: propertyMeta(
      "priceOverrideMin",
      false,
      false,
      false,
      MetaTypesBase.number,
    ),
    priceOverrideMax: propertyMeta(
      "priceOverrideMax",
      false,
      false,
      false,
      MetaTypesBase.number,
    ),
    priceCents: propertyMeta(
      "priceCents",
      false,
      false,
      false,
      MetaTypesBase.number,
    ),
  },
);

const metaI = CatalogItemInstanceReportItemInstanceDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ItemInstanceRefMeta]);
  metaI.assignId.inheritedFrom = ItemInstanceRefMeta.assignId;
  metaI.tempID.inheritedFrom = ItemInstanceRefMeta.tempID;
  metaI.interfaces = metaI.interfaces.concat([ItemInstanceBaseMeta]);
  metaI.assignId.inheritedFrom = ItemInstanceBaseMeta.assignId;
  metaI.tempID.inheritedFrom = ItemInstanceBaseMeta.tempID;
  metaI.startActive.inheritedFrom = ItemInstanceBaseMeta.startActive;
  metaI.endActive.inheritedFrom = ItemInstanceBaseMeta.endActive;
  metaI.ignoreStock.inheritedFrom = ItemInstanceBaseMeta.ignoreStock;
  metaI.minQuantity.inheritedFrom = ItemInstanceBaseMeta.minQuantity;
  metaI.maxQuantity.inheritedFrom = ItemInstanceBaseMeta.maxQuantity;
  metaI.allowPriceOverride.inheritedFrom =
    ItemInstanceBaseMeta.allowPriceOverride;
  metaI.priceOverrideMin.inheritedFrom = ItemInstanceBaseMeta.priceOverrideMin;
  metaI.priceOverrideMax.inheritedFrom = ItemInstanceBaseMeta.priceOverrideMax;
  metaI.priceCents.inheritedFrom = ItemInstanceBaseMeta.priceCents;
});

export class CatalogItemInstanceReportItemInstanceDTOTracked
  extends ItemInstanceBaseTracked
  implements CatalogItemInstanceReportItemInstanceDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  ignoreStock__I?: boolean = undefined;
  ignoreStockIsSet: boolean = false;
  set ignoreStock(v: undefined | boolean) {
    if (v !== undefined) {
      this.ignoreStock__I = v;
      this.ignoreStockIsSet = true;
    } else {
      this.ignoreStock__I = v || undefined;
      this.ignoreStockIsSet = false;
    }
    this.changeTracker = true;
  }
  get ignoreStock() {
    return this.ignoreStock__I;
  }
  minQuantity__I?: number = undefined;
  minQuantityIsSet: boolean = false;
  set minQuantity(v: undefined | number) {
    if (v !== undefined) {
      this.minQuantity__I = v;
      this.minQuantityIsSet = true;
    } else {
      this.minQuantity__I = v || undefined;
      this.minQuantityIsSet = false;
    }
    this.changeTracker = true;
  }
  get minQuantity() {
    return this.minQuantity__I;
  }
  maxQuantity__I?: number = undefined;
  maxQuantityIsSet: boolean = false;
  set maxQuantity(v: undefined | number) {
    if (v !== undefined) {
      this.maxQuantity__I = v;
      this.maxQuantityIsSet = true;
    } else {
      this.maxQuantity__I = v || undefined;
      this.maxQuantityIsSet = false;
    }
    this.changeTracker = true;
  }
  get maxQuantity() {
    return this.maxQuantity__I;
  }
  allowPriceOverride__I?: boolean = undefined;
  allowPriceOverrideIsSet: boolean = false;
  set allowPriceOverride(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowPriceOverride__I = v;
      this.allowPriceOverrideIsSet = true;
    } else {
      this.allowPriceOverride__I = v || undefined;
      this.allowPriceOverrideIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowPriceOverride() {
    return this.allowPriceOverride__I;
  }
  priceOverrideMin__I?: number = undefined;
  priceOverrideMinIsSet: boolean = false;
  set priceOverrideMin(v: undefined | number) {
    if (v !== undefined) {
      this.priceOverrideMin__I = v;
      this.priceOverrideMinIsSet = true;
    } else {
      this.priceOverrideMin__I = v || undefined;
      this.priceOverrideMinIsSet = false;
    }
    this.changeTracker = true;
  }
  get priceOverrideMin() {
    return this.priceOverrideMin__I;
  }
  priceOverrideMax__I?: number = undefined;
  priceOverrideMaxIsSet: boolean = false;
  set priceOverrideMax(v: undefined | number) {
    if (v !== undefined) {
      this.priceOverrideMax__I = v;
      this.priceOverrideMaxIsSet = true;
    } else {
      this.priceOverrideMax__I = v || undefined;
      this.priceOverrideMaxIsSet = false;
    }
    this.changeTracker = true;
  }
  get priceOverrideMax() {
    return this.priceOverrideMax__I;
  }
  priceCents__I?: number = undefined;
  priceCentsIsSet: boolean = false;
  set priceCents(v: undefined | number) {
    if (v !== undefined) {
      this.priceCents__I = v;
      this.priceCentsIsSet = true;
    } else {
      this.priceCents__I = v || undefined;
      this.priceCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get priceCents() {
    return this.priceCents__I;
  }
  constructor(
    config?: CatalogItemInstanceReportItemInstanceDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: CatalogItemInstanceReportItemInstanceDTOOptional,
    options?: AssignOptions,
  ): CatalogItemInstanceReportItemInstanceDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (
      config.ignoreStock &&
      this.ignoreStockApplyFilter(optionsRequired.filter)
    ) {
      this.ignoreStock = config.ignoreStock;
      if (optionsRequired.unassign) this.ignoreStockIsSet = false;
      else this.ignoreStockIsSet = true;
    }
    if (
      config.minQuantity &&
      this.minQuantityApplyFilter(optionsRequired.filter)
    ) {
      this.minQuantity = config.minQuantity;
      if (optionsRequired.unassign) this.minQuantityIsSet = false;
      else this.minQuantityIsSet = true;
    }
    if (
      config.maxQuantity &&
      this.maxQuantityApplyFilter(optionsRequired.filter)
    ) {
      this.maxQuantity = config.maxQuantity;
      if (optionsRequired.unassign) this.maxQuantityIsSet = false;
      else this.maxQuantityIsSet = true;
    }
    if (
      config.allowPriceOverride &&
      this.allowPriceOverrideApplyFilter(optionsRequired.filter)
    ) {
      this.allowPriceOverride = config.allowPriceOverride;
      if (optionsRequired.unassign) this.allowPriceOverrideIsSet = false;
      else this.allowPriceOverrideIsSet = true;
    }
    if (
      config.priceOverrideMin &&
      this.priceOverrideMinApplyFilter(optionsRequired.filter)
    ) {
      this.priceOverrideMin = config.priceOverrideMin;
      if (optionsRequired.unassign) this.priceOverrideMinIsSet = false;
      else this.priceOverrideMinIsSet = true;
    }
    if (
      config.priceOverrideMax &&
      this.priceOverrideMaxApplyFilter(optionsRequired.filter)
    ) {
      this.priceOverrideMax = config.priceOverrideMax;
      if (optionsRequired.unassign) this.priceOverrideMaxIsSet = false;
      else this.priceOverrideMaxIsSet = true;
    }
    if (
      config.priceCents &&
      this.priceCentsApplyFilter(optionsRequired.filter)
    ) {
      this.priceCents = config.priceCents;
      if (optionsRequired.unassign) this.priceCentsIsSet = false;
      else this.priceCentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(
    filter?: FilterVarsType,
  ): CatalogItemInstanceReportItemInstanceDTOTrackedI {
    const cloned = {} as CatalogItemInstanceReportItemInstanceDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.ignoreStockIsSetDeep() &&
      this.ignoreStockApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ignoreStockIsSet = true;
      cloned.ignoreStock = this.ignoreStock;
    } else {
      //cloned.ignoreStockIsSet = false
    }
    if (
      this.minQuantityIsSetDeep() &&
      this.minQuantityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.minQuantityIsSet = true;
      cloned.minQuantity = this.minQuantity;
    } else {
      //cloned.minQuantityIsSet = false
    }
    if (
      this.maxQuantityIsSetDeep() &&
      this.maxQuantityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.maxQuantityIsSet = true;
      cloned.maxQuantity = this.maxQuantity;
    } else {
      //cloned.maxQuantityIsSet = false
    }
    if (
      this.allowPriceOverrideIsSetDeep() &&
      this.allowPriceOverrideApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowPriceOverrideIsSet = true;
      cloned.allowPriceOverride = this.allowPriceOverride;
    } else {
      //cloned.allowPriceOverrideIsSet = false
    }
    if (
      this.priceOverrideMinIsSetDeep() &&
      this.priceOverrideMinApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceOverrideMinIsSet = true;
      cloned.priceOverrideMin = this.priceOverrideMin;
    } else {
      //cloned.priceOverrideMinIsSet = false
    }
    if (
      this.priceOverrideMaxIsSetDeep() &&
      this.priceOverrideMaxApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceOverrideMaxIsSet = true;
      cloned.priceOverrideMax = this.priceOverrideMax;
    } else {
      //cloned.priceOverrideMaxIsSet = false
    }
    if (
      this.priceCentsIsSetDeep() &&
      this.priceCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceCentsIsSet = true;
      cloned.priceCents = this.priceCents;
    } else {
      //cloned.priceCentsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(
    filter?: FilterVarsType,
  ): CatalogItemInstanceReportItemInstanceDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.ignoreStockApplyFilter(filter)) this.ignoreStockIsSet = false;

    if (!this.minQuantityApplyFilter(filter)) this.minQuantityIsSet = false;

    if (!this.maxQuantityApplyFilter(filter)) this.maxQuantityIsSet = false;

    if (!this.allowPriceOverrideApplyFilter(filter))
      this.allowPriceOverrideIsSet = false;

    if (!this.priceOverrideMinApplyFilter(filter))
      this.priceOverrideMinIsSet = false;

    if (!this.priceOverrideMaxApplyFilter(filter))
      this.priceOverrideMaxIsSet = false;

    if (!this.priceCentsApplyFilter(filter)) this.priceCentsIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportItemInstanceDTOMeta.assignId,
      CatalogItemInstanceReportItemInstanceDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportItemInstanceDTOMeta.tempID,
      CatalogItemInstanceReportItemInstanceDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportItemInstanceDTOMeta.startActive,
      CatalogItemInstanceReportItemInstanceDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportItemInstanceDTOMeta.endActive,
      CatalogItemInstanceReportItemInstanceDTOMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  ignoreStockApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportItemInstanceDTOMeta.ignoreStock,
      CatalogItemInstanceReportItemInstanceDTOMeta,
      this.ignoreStock,
      this,
    );
  }
  ignoreStockIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ignoreStockIsSet && this.ignoreStockApplyFilter(filter))
      return true;

    return false;
  }
  minQuantityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportItemInstanceDTOMeta.minQuantity,
      CatalogItemInstanceReportItemInstanceDTOMeta,
      this.minQuantity,
      this,
    );
  }
  minQuantityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.minQuantityIsSet && this.minQuantityApplyFilter(filter))
      return true;

    return false;
  }
  maxQuantityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportItemInstanceDTOMeta.maxQuantity,
      CatalogItemInstanceReportItemInstanceDTOMeta,
      this.maxQuantity,
      this,
    );
  }
  maxQuantityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.maxQuantityIsSet && this.maxQuantityApplyFilter(filter))
      return true;

    return false;
  }
  allowPriceOverrideApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportItemInstanceDTOMeta.allowPriceOverride,
      CatalogItemInstanceReportItemInstanceDTOMeta,
      this.allowPriceOverride,
      this,
    );
  }
  allowPriceOverrideIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.allowPriceOverrideIsSet &&
      this.allowPriceOverrideApplyFilter(filter)
    )
      return true;

    return false;
  }
  priceOverrideMinApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportItemInstanceDTOMeta.priceOverrideMin,
      CatalogItemInstanceReportItemInstanceDTOMeta,
      this.priceOverrideMin,
      this,
    );
  }
  priceOverrideMinIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceOverrideMinIsSet && this.priceOverrideMinApplyFilter(filter))
      return true;

    return false;
  }
  priceOverrideMaxApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportItemInstanceDTOMeta.priceOverrideMax,
      CatalogItemInstanceReportItemInstanceDTOMeta,
      this.priceOverrideMax,
      this,
    );
  }
  priceOverrideMaxIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceOverrideMaxIsSet && this.priceOverrideMaxApplyFilter(filter))
      return true;

    return false;
  }
  priceCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportItemInstanceDTOMeta.priceCents,
      CatalogItemInstanceReportItemInstanceDTOMeta,
      this.priceCents,
      this,
    );
  }
  priceCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceCentsIsSet && this.priceCentsApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.ignoreStockIsSetDeep(filter)) return true;
    if (this.minQuantityIsSetDeep(filter)) return true;
    if (this.maxQuantityIsSetDeep(filter)) return true;
    if (this.allowPriceOverrideIsSetDeep(filter)) return true;
    if (this.priceOverrideMinIsSetDeep(filter)) return true;
    if (this.priceOverrideMaxIsSetDeep(filter)) return true;
    if (this.priceCentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
